var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"icon-holder",class:_vm.iconclass},'div',_vm.$attrs,false),_vm.listeners),[_vm._t("icon",function(){return [_c('span',{staticClass:"iconwrapper"},[_c('i',{class:_vm.icon})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }